import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UpDownChevronIconComponent } from '../../../icons/table/up-down-chevron-icon/up-down-chevron-icon.component';
import { ChevronIconComponent } from '../../../icons/table/chevron-icon/chevron-icon.component';
import { ARROWS } from '../../../../../shared/constants/arrows';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';

@Component({
  selector: 'app-header-sorter',
  imports: [UpDownChevronIconComponent, ChevronIconComponent, AgentActionDirective],
  templateUrl: './header-sorter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header-sorter.component.scss',
})
export class HeaderSorterComponent {
  @Input() public headerTitle = '';
  @Input() public field = '';
  @Input() public arrow = ARROWS.BOTH;
  @Output() public clicked = new EventEmitter<string>();

  public arrows = ARROWS;

  public onHeaderClicked(): void {
    this.clicked.emit(this.field);
  }
}
